import React from 'react';
import clsx from 'clsx';
import {
  Accordion, Icon,
} from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const AccordionHeader = ({
  active,
  error,
  index,
  onClick,
  headerId,
  headerText,
  children,
  className,
}) => (
  <>
    <Accordion.Title
      className={clsx('aridhia-accordion-header', className)}
      active={active}
      index={index}
      onClick={onClick}
    >
      <Icon name={error ? 'times circle' : 'dropdown'} className={error ? 'error' : 'primary'} />
      {headerId && (<FormattedMessage id={headerId} />)}
      {headerText}
      {children}
    </Accordion.Title>
  </>
);

export default AccordionHeader;
